import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "welcome",
        // route level code-splitting
        // this generates a separate chunk (signup.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "welcome" */ '../views/Welcome.vue')
    },
    {
        path: "/get-started",
        name: "get-started",
        component: () => import(/* webpackChunkName: "get-started" */ '../views/GetStarted.vue')
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import(/* webpackChunkName: "signup" */ '../views/SignUp.vue')
    },
    {
        path: '/sign-in',
        name: 'sign-in',
        component: () => import(/* webpackChunkName: "signin" */ '../views/SignIn.vue')
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
            if (store.state.auth.accessToken) {
                store.dispatch('logout')
            }
            next({name: 'sign-in'});
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue')
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import(/* webpackChunkName: "feedback" */ '../views/FeedbackPage.vue')
    },
    {
        path: '/register',
        redirect: '/sign-up',
    },
    {
        path: '/email/verify/:id/:hash',
        beforeEnter: (to, from, next) => {
            const {expires} = to.query;
            const {signature} = to.query;

            if (store.state.auth.accessToken) {
                store.dispatch('verifyEmail',
                    {id: to.params.id, hash: to.params.hash, expires, signature}).finally(() => {
                    next('/get-started');
                })
            } else {
                next({name: 'sign-in', params: {verifyData: {id: to.params.id, hash: to.params.hash, expires, signature}}});
            }

        }
    },
    {
        path: '/password/reset/:token',
        name: 'password-reset',
        component: () => import(/* webpackChunkName: "feedback" */ '../views/PasswordReset.vue')
    },
    {
        path: '*',
        redirect: '/sign-in',
    },
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router
